import _defineProperty from "babel-runtime/helpers/defineProperty";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable eqeqeq */
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
import axios from 'axios';
import moment from 'moment';
import Flickity from 'flickity';

var createHistory = require('history').createBrowserHistory;

var history = createHistory();

var customMethods = {
  data: function data() {
    return {
      // your data here
      cartNoteFirstOrder: false,
      checkoutEnable: false,
      disableCheckout: true
    };
  },


  methods: {
    _initCustomMethods: function _initCustomMethods() {
      // custom JS code


      if ($('body').hasClass('template-product')) {
        var productURL = window.location.pathname;
        console.log(productURL);
        if (productURL == '/products/large-disposable-doggielawn') {
          window.location.href = 'https://doggielawn.com/products/disposable-doggielawn?variant=41722222215357';
        } else if (productURL == '/products/disp-mini-doggielawn-subscription') {
          window.location.href = 'https://doggielawn.com/products/disposable-doggielawn?variant=41722222117053';
        } else if (productURL == '/products/disp-doggielawn') {
          window.location.href = 'https://doggielawn.com/products/disposable-doggielawn?variant=41722222149821';
        }
        var productFullURL = window.location.href;
        var pro_url = productFullURL.split('?')[1];
        var finalURL = productURL + '?' + pro_url;

        if (finalURL == '/products/doggielawn-bundle-subscription?variant=41572556308669') {
          window.location.href = 'https://doggielawn.com/products/doggielawn-bundle?variant=41535777865917';
        } else if (finalURL == '/products/doggielawn-bundle-subscription?variant=41572556275901') {
          window.location.href = 'https://doggielawn.com/products/doggielawn-bundle?variant=39449937543357';
        } else if (finalURL == '/products/doggielawn-bundle-subscription?variant=41572556243133') {
          window.location.href = 'https://doggielawn.com/products/doggielawn-bundle?variant=39449937510589';
        } else if (finalURL == '/products/doggielawn-bundle-subscription?variant=41572556210365') {
          window.location.href = 'https://doggielawn.com/products/doggielawn-bundle?variant=39449937477821';
        }
      }

      setTimeout(function () {
        if (document.querySelector('.ju_Con') != null && document.querySelector('[data-floating-atc]') != null) {
          var headerHeight = document.querySelector('[data-site-header]').clientHeight;
          var topBarHeight = document.querySelector('.ju_Con').clientHeight;

          var totalTopBarHeight = headerHeight + topBarHeight - 10;
          document.querySelector('[data-floating-atc]').style.top = totalTopBarHeight + 'px';
        } else if (document.querySelector('[data-floating-atc]') != null) {
          var _headerHeight = document.querySelector('[data-site-header]').clientHeight;
          document.querySelector('[data-floating-atc]').style.top = _headerHeight + 'px';
        }
      }, 7000);

      // $('body').on('click', '.design-layer .design-layer-editable', function(event){
      //   event.preventDefault();

      // });


      app._fixedTitle();
      app._newsLatter();
      app._pickYourPlan();
      app._pickYourPrepaid();
      if (window.theme.lastOrderId != '') {
        app._orderDate();
      }
      // Clear note when customer have already order and placed within 6 months
      app._clearOrderNote();
      app._megamenuOpen();
      app._HeaderSticky();
      app._addAccSol();
      $('[data-skip-content]').on('keydown', function (e) {
        if (e.keyCode === 13) {
          $(this).trigger('click');
        }
        $(this).remove();
      });

      if (app.currentTemplate == 'training') {
        if ($('.has_smile_customer').length > 0) {

          var smile_customer_id = $('.smile-shopify-init').attr('data-customer-id');

          var tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function () {
            var player;
            function onYouTubePlayerAPIReady() {
              player = new YT.Player('smile_customer', {
                height: '315',
                width: '560',
                videoId: 'AuSZcwB-raM',
                events: {
                  'onStateChange': onPlayerStateChange
                }
              });
            }

            var myPlayerState;
            function onPlayerStateChange(event) {
              if (event.data == YT.PlayerState.PLAYING) {
                var disData = new FormData();
                disData.append('shopify_customer_id', smile_customer_id);
                axios({
                  method: 'post',
                  url: 'https://scripts.doggielawn.com/Doggielawn/api_watch_video_create_activity_smile.php',
                  data: disData,
                  headers: { 'Content-Type': 'application/json' }
                })
                // eslint-disable-next-line promise/always-return
                .then(function (response) {
                  // handle success
                  console.log(response);
                });
              }
              myPlayerState = event.data;
            }
            onYouTubePlayerAPIReady();
          }, 1000);
        }

        /*if($('.has_smile_customer').length > 0){
          var headers = {
            'Content-Type': 'application/json',
            'Authorization':'Bearer int_hcCeJXxdssfj-JY9xYx6',
          }
          var smile_customer_id = $('.smile-shopify-init').attr('data-customer-id');
          const config = {
            activity: {
              'customer_id' : smile_customer_id,
              'token' : 'activity_o9LcsXDbghKbLOah26phv2mE'
            }
        }
        console.log(config);
          $.ajax({
            type: 'POST',
            url: "https://api.smile.io/v1/activities",
            headers: headers,
            data: config,
            success: function (response) {
             console.log(response,'= response');
            },
            error: function (error) {
              console.log(error,"= error");
            }
          });*/
        /*Smile.createActivity({ token: 'activity_o9LcsXDbghKbLOah26phv2mE' })
        .then(function(activity) {
          // Success
          //console.log('Created activity ' + activity.id);
        }).catch(function(err) {
          // Failure
          //console.log('Something went wrong');
        });
        }*/
      }
      setTimeout(function () {
        if (app.currentTemplate == 'collection' && app.collection.title == 'Shop') {
          enquire.register('screen and (max-width: 767px)', {
            match: function match() {
              var $carousel1 = $('[data-shop-coll-products]');
              var options1 = {
                adaptiveHeight: true,
                draggable: true,
                contain: true,
                cellAlign: 'left',
                wrapAround: true,
                accessibility: true,
                dragThreshold: 20,
                lazyLoad: false,
                pageDots: true,
                prevNextButtons: false
              };
              $($carousel1).each(function (i, ele) {
                new Flickity(ele, options1);
              });
            }
          });
          // eslint-disable-next-line shopify/jquery-dollar-sign-reference
          var nav = $('[data-coll-sidebar]');
          var headerHeight = $('[data-site-header]').css('height');

          var bottom = nav.offset().top;
          // eslint-disable-next-line shopify/jquery-dollar-sign-reference
          var divs = $('[data-collections]');
          var nav_height = nav.outerHeight();
          $(window).scroll(function () {
            if ($(this).scrollTop() > bottom) {
              nav.addClass('sticky-top');
              nav.css('padding-top', headerHeight);
            } else {
              nav.removeClass('sticky-top');
              nav.css('padding-top', 'unset');
            }
            var cur_pos = $(this).scrollTop();
            divs.each(function () {
              var top = $(this).offset().top - nav_height;
              var bottom = top + $(this).outerHeight();
              // if (cur_pos >= top && cur_pos <= bottom) {
              //   nav.find('a').removeClass('text-black');
              //   nav.find(`a[href="#${$(this).attr('id')}"]`).addClass('text-black');
              // }
            });
          });
        }
        if (app.currentTemplate == 'cart') {
          enquire.register('screen and (max-width: 767px)', {
            match: function match() {
              $('#chat-widget-container').css('display', 'none');
            }
          });
        }
        $('#smile-ui-container').css('z-index', "214");
      }, 3000);
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var chat_page = $('#doggielawn-live-chat');
      if (chat_page.length > 0) {
        app._gorgias();
      }

      $('[loyalty_slider]').on('click', function () {
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 50);
      });
      $('body').on('change', '[data-change-state]', function (event) {
        var state = $(event.currentTarget).val();
        var stateName = $(event.currentTarget).find('option:selected').data('state');
        window.location.href = "/pages/pick-your-frequency#handle=" + state + "&" + stateName;
      });
      $('body').on('change', '[data-prepaid-change-state]', function (event) {
        var state = $(event.currentTarget).val();
        var stateName = $(event.currentTarget).find('option:selected').data('state');
        window.location.href = "/pages/pick-prepaid-frequency#handle=" + state + "&" + stateName;
      });
      window.addEventListener('load', function (event) {
        app.disableCheckout = false;
      });
      $('body').on('keydown', '[data-label-check]', function (event) {
        if (event.keyCode == 32) {
          $(event.currentTarget).trigger('click');
        }
      });
      $('body').on('change', '[data-checked-cart]', function (event) {
        if ($(event.currentTarget).prop('checked') == true) {
          app.checkoutEnable = true;
        } else {
          app.checkoutEnable = false;
        }
      });

      // Added nofollow in help menu
      $(document).ready(function () {
        $("[aria-label='Help']").attr('rel', 'nofollow');
      });

      // let url = window.location.href;
      // if (url.indexOf('/subscriptions') > -1) {
      //   url = url.replace('https://doggielawn.myshopify.com/', '').replace('customers', 'customer').replace('subscriptions', 'account');
      //   url = url.replace('tools/recurring/customer/36222447390b0b3f2c51acf5/', '');
      //   history.push(url, 'Doggie Lawn', url);
      //   location.reload();
      // }

      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'blog' || app.currentTemplate == 'article') {
        app._newsLatterBlog();
      }

      app._sameHeight();
      // eslint-disable-next-line eqeqeq

      if (app.currentTemplate == 'index') {
        app._videoPlayer();
      }

      if ($(".rise-ai-giftcard").length > 0) {
        var myvar = setInterval(function () {
          if ($(".cart-wrap button.gwbutton").length > 0) {
            clearInterval(myvar);
            $(".cart-wrap button.gwbutton").removeClass("d-none");
          }
        }, 500);
      }

      var video = document.querySelector('.hb-video');
      if (video) {
        video.id = window.innerWidth > 991 ? 'play-button' : 'play-button-mobile';
      }
    },

    // eslint-disable-next-line space-before-blocks
    _addAccSol: function _addAccSol() {
      if (app.currentTemplate == "index" || app.currentTemplate == "product") {
        if (app.currentTemplate == "index") {
          // eslint-disable-next-line prefer-arrow-callback
          // setTimeout(function() {
          //   $('.yotpo-carousel > .y-slider-container.y-slide-left-animations[role="list"]').removeAttr('role');
          // },7000)
        } else if (app.currentTemplate == "product") {
          // eslint-disable-next-line prefer-arrow-callback
          if (app.product.handle == 'rise-ai-giftcard') {
            setTimeout(function () {
              $('.Rise-popup-close-button').attr('aria-label', 'close');
            }, 15000);
          }
        }
      }
      if (window.location.href.includes('/pages/reviews')) {

        $('body').on('keydown', function (event) {
          var keyCode = window.event ? event.which : event.keyCode;
          if (keyCode == 9) {
            if ($(event.target)[0].id == 'testimonials-modal-dialog-ends') {
              $('.question_box_wrap h2').trigger('focus');
            }
          }
        });
      }
      $('body').on('keydown', function (event) {
        var keyCode = window.event ? event.which : event.keyCode;
        if (keyCode == 9) {
          if ($(event.target)[0].id == 'searchInput') {
            $('.snize-ac-results').attr('tabindex', '0');
            $('.snize-ac-results').trigger('focus');
          }
        }
      });
    },
    _HeaderSticky: function _HeaderSticky() {
      if ($('[data-site-header]').hasClass('fixed-top')) {
        var offsetHeight = document.querySelector('[data-site-header]').offsetHeight;
        document.querySelector('#app').style.padding = offsetHeight + 'px 0 0 0';
      }
      enquire.register('screen and (max-width: 768px)', {
        match: function match() {
          if ($('[data-site-header]').hasClass('fixed-mobile-top') && !$('[data-site-header]').hasClass('fixed-top')) {
            var _offsetHeight = document.querySelector('[data-site-header]').offsetHeight;
            document.querySelector('#app').style.padding = _offsetHeight + 'px 0 0 0';
          }
        }
      });
    },
    _megamenuOpen: function _megamenuOpen() {
      if ($('#megamenu').hasClass('active')) {
        $('#megamenu').removeClass('active');
      }
      $("#megamenu").on('click', function () {
        var $this = $(this);
        if (!$this.hasClass('active')) {
          $this.addClass('active');
        } else {
          $this.removeClass('active');
        }
      });

      $(document).mouseup(function (e) {
        var elem = $("#mega-menu-wrap");
        if (!elem.is(e.target) && elem.has(e.target).length == 0) {
          $('#megamenu').removeClass('active');
        }
      });
    },
    _scrollToTop: function _scrollToTop() {
      window.scrollTo(0, 0);
    },
    _orderDate: function _orderDate() {
      // eslint-disable-next-line promise/catch-or-return
      axios.post("https://scripts.doggielawn.com/Doggielawn/getOrderProcessDate.php?order_id=" + window.theme.lastOrderId)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        console.log(response, 'responce customm===========');
        // eslint-disable-next-line promise/always-return
        if (response.data) {
          // eslint-disable-next-line promise/always-return
          if (response.data.message != 'Something went Wrong!. Order Not Found.') {
            var afterMonth = moment(response.data.data.processed_at).add(6, 'month').format('MMMM DD, YYYY');
            // eslint-disable-next-line promise/always-return

            if (moment(window.theme.todaysDate).format('YYYY-MM-DD') >= moment(afterMonth).format('YYYY-MM-DD')) {
              app.cartNoteFirstOrder = true;
            } else {
              app.cartNoteFirstOrder = false;
            }
          }
        }
      });
    },
    _clearOrderNote: function _clearOrderNote() {
      // Clear note when customer have already order and placed within 6 months
      if (!app.cartNoteFirstOrder) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: { note: '' },
          dataType: 'json'

        });
      }
    },
    _videoPlayer: function _videoPlayer(event) {
      // eslint-disable-next-line no-var
      // eslint-disable-next-line block-scoped-var
      var playButton = '';
      var vid = document.querySelector('[data-header-video]');
      // bind events
      if ($(window).width() > 991) {
        playButton = document.getElementById('play-button');
      } else {
        playButton = document.getElementById('play-button-mobile');
      }
      if (playButton != null) {
        playButton.addEventListener('click', function () {
          var vidSrc = vid.getAttribute('data-src');
          if (document.querySelector('[data-header-video] source').getAttribute('src') == '') {
            document.querySelector('[data-header-video] source').setAttribute('src', vidSrc);
            vid.autoplay = true;
            vid.load();
          } else {
            vid.play();
          }
        });
        window.addEventListener('keydown', function (e) {
          var keyCode = window.event ? e.which : e.keyCode;
          if ($(e.target).attr('id') == 'play-button' || $(e.target).attr('id') == 'play-button-mobile') {
            if (keyCode == 13) {
              $(playButton).trigger('click');
            }
          }
          if (vid.currentTime > 0 && keyCode == 27) {
            $(pauseButton).trigger('click');
          }
        });
      }

      var pauseButton = document.getElementById('pause-button');
      if (pauseButton != null) {
        pauseButton.addEventListener('click', function () {
          vid.pause();
        });
      }
    },
    _fixedTitle: function _fixedTitle(event) {
      var fixed_title_height = $('.fixed_title').height();
      $('footer').css('padding-bottom', fixed_title_height);
    },
    _sameHeight: function _sameHeight(event) {
      var height_main = $('[data-section-height-main]').height();
      $('[data-section-height]').css('height', height_main);
    },
    _IsEmail: function _IsEmail(email) {
      var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!regex.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    _emailblank: function _emailblank() {
      $('#email_signup').find('[data-subscribe-msg]').text("Email is can't be blank.").attr('class', 'text-danger position-absolute').fadeIn().delay(2000).fadeOut();
    },
    _emailblankBlog: function _emailblankBlog() {
      $('#email_signup_blog').find('[data-subscribe-msg-blog]').text("Email is can't be blank.").attr('class', 'text-danger position-absolute').fadeIn().delay(2000).fadeOut();
    },
    _newsLatter: function _newsLatter(event) {
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      $('[data-formsubmit]').click(function () {
        var form = $(this).closest('form');
        var email = form.find('#k_id_email').val();
        // eslint-disable-next-line eqeqeq
        if (email != undefined) {
          if (email.length > 0) {
            if (!app._IsEmail(email)) {
              $('#email_signup').find('[data-subscribe-msg]').text('Email is not valid.').attr('class', 'text-danger position-absolute').fadeIn().delay(2000).fadeOut();
              return false;
            } else {
              $('[data-submit-form]').trigger('click');
            }
          } else {
            app._emailblank();
          }
        } else {
          app._emailblank();
        }
      });
    },
    _photoGallery: function _photoGallery(event) {
      var image_url = $(event.currentTarget).attr('data-image');
      $('[data-photo-gallery]').attr('src', image_url);
    },
    _newsLatterBlog: function _newsLatterBlog(event) {
      if (app.currentTemplate == 'blog' || app.currentTemplate == 'article') {
        $('[data-formsubmit-blog]').click(function () {
          // eslint-disable-next-line shopify/jquery-dollar-sign-reference
          var form = $(this).closest('form');
          var email = form.find('#k_id_email_blog').val();
          // eslint-disable-next-line eqeqeq
          if (email != undefined) {
            if (email.length > 0) {
              if (!app._IsEmail(email)) {
                $('#email_signup_blog').find('[data-subscribe-msg-blog]').text('Email is not valid.').attr('class', 'text-danger position-absolute').fadeIn().delay(2000).fadeOut();
                return false;
              } else {
                $('[data-formsubmit-blog]').trigger('click');
              }
            } else {
              app._emailblankBlog();
            }
          } else {
            app._emailblankBlog();
          }
        });
      }
    },
    _pickYourPlanMain: function _pickYourPlanMain(event, match) {
      window.location.href = "/pages/pick-your-frequency#handle=" + match;
    },
    _pickYourPrepaidMain: function _pickYourPrepaidMain(event, match) {
      window.location.href = "/pages/pick-prepaid-frequency#handle=" + match;
    },
    _pickYourPlan: function _pickYourPlan(event) {
      var url = window.location.href;
      url = url.split('#handle=')[1];
      // eslint-disable-next-line eqeqeq
      if (url != undefined) {
        if (url.indexOf('&') > -1) {
          var st = url.split('&')[1].replace('-', ' ');
          url = url.split('&')[0];
          app.pickYourPlan.grass.selectedState = st;
        }
        // eslint-disable-next-line eqeqeq
        // if (url == 'group-3') {
        //   $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass]').removeClass('d-none');
        //   $('[data-frequently]').addClass('d-none');
        // // eslint-disable-next-line eqeqeq
        // } else if (url == 'group-2') {
        //   $('[data-grass-eastern]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass-original-group-3]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass]').removeClass('d-none');
        //   $('[data-frequently]').addClass('d-none');
        // }

        if (url == 'group-3' || url == 'group-2') {
          $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
          $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
          $('[data-grass]').removeClass('d-none');
          $('[data-frequently]').addClass('d-none');
          // eslint-disable-next-line eqeqeq
        }
        var addData = url;
        if (url.indexOf('group') > -1) {
          addData = 'xl';
        }
        app.pickYourPlan.selectedStage = url;
        app.pickYourPlan.selectedProduct = addData;
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var $allProduct = $(app.selectors.allProduct);
        var variantObj = $($allProduct).find("[data-product-" + url + "]").html();
        var variantData = JSON.parse(variantObj);
        app.pickYourPlan.selectedProduct_id = variantData.product_id;
        app.pickYourPlan.variantsGroup = variantData.variants;
        app.pickYourPlan.mostPopular = variantData.popular;
        app.pickYourPlan.shipping_interval_frequency = variantData.shipping_interval_frequency;
        app.pickYourPlan.shipping_interval_unit_type = variantData.shipping_interval_unit_type;
        app.pickYourPlan.subscription_id = variantData.subscription_id;
      }
    },
    _pickYourPrepaid: function _pickYourPrepaid(event) {
      console.log('_pickYourPrepaid');
      var url = window.location.href;
      url = url.split('#handle=')[1];
      // eslint-disable-next-line eqeqeq
      if (url != undefined) {
        if (url.indexOf('&') > -1) {
          var st = url.split('&')[1].replace('-', ' ');
          url = url.split('&')[0];
          app.pickYourPlan.grass.selectedState = st;
        }
        // eslint-disable-next-line eqeqeq
        // if (url == 'group-3') {
        //   $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass]').removeClass('d-none');
        //   $('[data-frequently]').addClass('d-none');
        // // eslint-disable-next-line eqeqeq
        // } else if (url == 'group-2') {
        //   $('[data-grass-eastern]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass-original-group-3]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass]').removeClass('d-none');
        //   $('[data-frequently]').addClass('d-none');
        // }

        if (url == 'group-3' || url == 'group-2') {
          $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
          $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
          $('[data-grass]').removeClass('d-none');
          $('[data-frequently]').addClass('d-none');
          // eslint-disable-next-line eqeqeq
        }
        var addData = url;
        if (url.indexOf('group') > -1) {
          addData = 'xl';
        }
        app.pickYourPrepaid.selectedStage = url;
        app.pickYourPrepaid.selectedProduct = addData;
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var $allProduct = $(app.selectors.allProduct);
        var variantObj = $($allProduct).find("[data-product-" + url + "]").html();
        var variantData = JSON.parse(variantObj);
        app.pickYourPrepaid.variantsGroup = variantData.variants;
        app.pickYourPrepaid.mostPopular = variantData.popular;
        app.pickYourPrepaid.shipping_interval_frequency = variantData.shipping_interval_frequency;
        app.pickYourPrepaid.shipping_interval_unit_type = variantData.shipping_interval_unit_type;
        app.pickYourPrepaid.charge_interval_frequency = variantData.charge_interval_frequency;
        app.pickYourPrepaid.subscription_id = variantData.subscription_id;
        app.pickYourPrepaid.selectedProductprice = variantData.price;
      }
    },
    _nextStepMonthSelection: function _nextStepMonthSelection(event, variant_name) {
      app.pickYourPrepaid.selectedMonth = variant_name;
      app.pickYourPrepaid.month.selectedMonth = variant_name;
      if (variant_name === '1 Delivery') {
        var week = '';
        var month = '1 Delivery';
        if (app.pickYourPrepaid.selectedStage == 'group-2') {
          week = "Central local Every Week";
        } else if (app.pickYourPrepaid.selectedStage == 'group-3') {
          week = "Local Every Week";
        } else {
          week = "Every Week";
        }
        var variant_group = week + ' / ' + month;
        app.pickYourPrepaid.variantsGroup.forEach(function (item) {
          if (item.title == variant_group) {
            var variantID = item.id;
            var image = app._getSizedImageUrl(item.featured_image, '150x');
            var variantTitle = item.title;
            var productName = app.pickYourPrepaid.selectedProduct;
            app._pickYourPrepaidFrequently(event, productName, variantTitle, month, image, variantID);
          }
        });
      } else {
        $('.data-prepaid-months').addClass('d-none');
        $('.data-prepaid-weeks').removeClass('d-none');
        $('[data-changed-week]').removeClass('d-none');
        $(event.currentTarget).parents('[data-prepaid-months]').addClass('d-none');
        if (app.pickYourPrepaid.selectedStage == 'group-2') {
          if (app.pickYourPrepaid.grass.grassType == 'Hydroponic') {
            $(event.currentTarget).parents('[data-prepaid-months]').nextAll('[data-group2-hydroponic-weeks]').removeClass('d-none');
          } else {
            $(event.currentTarget).parents('[data-prepaid-months]').nextAll('[data-central-weeks]').removeClass('d-none');
          }
        } else if (app.pickYourPrepaid.selectedStage == 'group-3') {
          if (app.pickYourPrepaid.grass.grassType == 'Hydroponic') {
            $(event.currentTarget).parents('[data-prepaid-months]').nextAll('[data-group3-hydroponic-weeks]').removeClass('d-none');
          } else {
            $(event.currentTarget).parents('[data-prepaid-months]').nextAll('[data-eastern-weeks]').removeClass('d-none');
          }
        } else {
          $(event.currentTarget).parents('[data-prepaid-months]').next('[data-prepaid-weeks]').removeClass('d-none');
        }
        app.pickYourPrepaid.selectedMonth = variant_name;
        app.pickYourPrepaid.selectedWeek = '';
        app.pickYourPrepaid.frequency.selectedFrequency = '';
        app.pickYourPrepaid.month.selectedMonth = variant_name;
        var url = window.location.href;
        url = url.split('#handle=')[1];
        if (url == 'standard') {
          var _price = 2600;
          var _price_new = 2700;
          var delivery_price_week_1 = _price;
          app.standardPriceEveryWeek.oneDelivery = delivery_price_week_1;
          var delivery_price_week_2 = _price * 1;
          app.standardPriceEveryTwoWeek.oneDelivery = delivery_price_week_2;
          var delivery_price_week_3 = _price_new * 1;
          app.standardPriceEveryThreeWeek.oneDelivery = delivery_price_week_3;
          var delivery_price_week_4 = _price_new * 1;
          app.standardPriceEveryFourWeek.oneDelivery = delivery_price_week_4;

          var threeDelivery_price_week_1 = _price * 3;
          app.standardPriceEveryWeek.threeDelivery = threeDelivery_price_week_1;
          var threeDelivery_price_week_2 = _price * 3;
          app.standardPriceEveryTwoWeek.threeDelivery = threeDelivery_price_week_2;
          var threeDelivery_price_week_3 = _price_new * 3;
          app.standardPriceEveryThreeWeek.threeDelivery = threeDelivery_price_week_3;
          var threeDelivery_price_week_4 = _price_new * 3;
          app.standardPriceEveryFourWeek.threeDelivery = threeDelivery_price_week_4;

          var sixDelivery_price_week_1 = _price * 6;
          app.standardPriceEveryWeek.sixDelivery = sixDelivery_price_week_1;
          var sixDelivery_price_week_2 = _price * 6;
          app.standardPriceEveryTwoWeek.sixDelivery = sixDelivery_price_week_2;
          var sixDelivery_price_week_3 = _price_new * 6;
          app.standardPriceEveryThreeWeek.sixDelivery = sixDelivery_price_week_3;
          var sixDelivery_price_week_4 = _price_new * 6;
          app.standardPriceEveryFourWeek.sixDelivery = sixDelivery_price_week_4;
        } else if (url == 'medium') {
          var _price2 = 2900;
          var _price_new2 = 3000;
          var _delivery_price_week_ = _price2;
          app.mediumPriceEveryWeek.oneDelivery = _delivery_price_week_;
          var _delivery_price_week_2 = _price2 * 1;
          app.mediumPriceEveryTwoWeek.oneDelivery = _delivery_price_week_2;
          var _delivery_price_week_3 = _price_new2 * 1;
          app.mediumPriceEveryThreeWeek.oneDelivery = _delivery_price_week_3;
          var _delivery_price_week_4 = _price_new2 * 1;
          app.mediumPriceEveryFourWeek.oneDelivery = _delivery_price_week_4;

          var _threeDelivery_price_week_ = _price2 * 3;
          app.mediumPriceEveryWeek.threeDelivery = _threeDelivery_price_week_;
          var _threeDelivery_price_week_2 = _price2 * 3;
          app.mediumPriceEveryTwoWeek.threeDelivery = _threeDelivery_price_week_2;
          var _threeDelivery_price_week_3 = _price_new2 * 3;
          app.mediumPriceEveryThreeWeek.threeDelivery = _threeDelivery_price_week_3;
          var _threeDelivery_price_week_4 = _price_new2 * 3;
          app.mediumPriceEveryFourWeek.threeDelivery = _threeDelivery_price_week_4;

          var _sixDelivery_price_week_ = _price2 * 6;
          app.mediumPriceEveryWeek.sixDelivery = _sixDelivery_price_week_;
          var _sixDelivery_price_week_2 = _price2 * 6;
          app.mediumPriceEveryTwoWeek.sixDelivery = _sixDelivery_price_week_2;
          var _sixDelivery_price_week_3 = _price_new2 * 6;
          app.mediumPriceEveryThreeWeek.sixDelivery = _sixDelivery_price_week_3;
          var _sixDelivery_price_week_4 = _price_new2 * 6;
          app.mediumPriceEveryFourWeek.sixDelivery = _sixDelivery_price_week_4;
        } else if (url == 'large') {
          var _price3 = 3100;
          var _price_new3 = 3200;
          var _delivery_price_week_5 = _price3;
          app.largePriceEveryWeek.oneDelivery = _delivery_price_week_5;
          var _delivery_price_week_6 = _price3 * 1;
          app.largePriceEveryTwoWeek.oneDelivery = _delivery_price_week_6;
          var _delivery_price_week_7 = _price_new3 * 1;
          app.largePriceEveryThreeWeek.oneDelivery = _delivery_price_week_7;
          var _delivery_price_week_8 = _price_new3 * 1;
          app.largePriceEveryFourWeek.oneDelivery = _delivery_price_week_8;

          var _threeDelivery_price_week_5 = _price3 * 3;
          app.largePriceEveryWeek.threeDelivery = _threeDelivery_price_week_5;
          var _threeDelivery_price_week_6 = _price3 * 3;
          app.largePriceEveryTwoWeek.threeDelivery = _threeDelivery_price_week_6;
          var _threeDelivery_price_week_7 = _price_new3 * 3;
          app.largePriceEveryThreeWeek.threeDelivery = _threeDelivery_price_week_7;
          var _threeDelivery_price_week_8 = _price_new3 * 3;
          app.largePriceEveryFourWeek.threeDelivery = _threeDelivery_price_week_8;

          var _sixDelivery_price_week_5 = _price3 * 6;
          app.largePriceEveryWeek.sixDelivery = _sixDelivery_price_week_5;
          var _sixDelivery_price_week_6 = _price3 * 6;
          app.largePriceEveryTwoWeek.sixDelivery = _sixDelivery_price_week_6;
          var _sixDelivery_price_week_7 = _price_new3 * 6;
          app.largePriceEveryThreeWeek.sixDelivery = _sixDelivery_price_week_7;
          var _sixDelivery_price_week_8 = _price_new3 * 6;
          app.largePriceEveryFourWeek.sixDelivery = _sixDelivery_price_week_8;
        }
        if (app.pickYourPrepaid.selectedStage == 'group-1') {
          var price = 3400;
          var price_new = 3800;
          var _delivery_price_week_9 = price;
          app.xlPricePriceEveryWeek.group1.oneDelivery = _delivery_price_week_9;
          var _delivery_price_week_10 = price * 1;
          app.xlPriceEveryTwoWeek.group1.oneDelivery = _delivery_price_week_10;
          var _delivery_price_week_11 = price_new * 1;
          app.xlPriceEveryThreeWeek.group1.oneDelivery = _delivery_price_week_11;
          var _delivery_price_week_12 = price_new * 1;
          app.xlPriceEveryFourWeek.group1.oneDelivery = _delivery_price_week_12;

          var _threeDelivery_price_week_9 = price * 3;
          app.xlPricePriceEveryWeek.group1.threeDelivery = _threeDelivery_price_week_9;
          var _threeDelivery_price_week_10 = price * 3;
          app.xlPriceEveryTwoWeek.group1.threeDelivery = _threeDelivery_price_week_10;
          var _threeDelivery_price_week_11 = price_new * 3;
          app.xlPriceEveryThreeWeek.group1.threeDelivery = _threeDelivery_price_week_11;
          var _threeDelivery_price_week_12 = price_new * 3;
          app.xlPriceEveryFourWeek.group1.threeDelivery = _threeDelivery_price_week_12;

          var _sixDelivery_price_week_9 = price * 6;
          app.xlPricePriceEveryWeek.group1.sixDelivery = _sixDelivery_price_week_9;
          var _sixDelivery_price_week_10 = price * 6;
          app.xlPriceEveryTwoWeek.group1.sixDelivery = _sixDelivery_price_week_10;
          var _sixDelivery_price_week_11 = price_new * 6;
          app.xlPriceEveryThreeWeek.group1.sixDelivery = _sixDelivery_price_week_11;
          var _sixDelivery_price_week_12 = price_new * 6;
          app.xlPriceEveryFourWeek.group1.sixDelivery = _sixDelivery_price_week_12;
        } else if (app.pickYourPrepaid.selectedStage == 'group-2') {
          var price = 0;
          var price_new = 0;
          if (app.pickYourPrepaid.grass.grassType == 'central Local') {
            price = 3400;
            price_new = 3800;
          } else if (app.pickYourPrepaid.grass.grassType == 'Hydroponic') {
            price = 4000;
            price_new = 4900;
          }
          var _delivery_price_week_13 = price;
          app.xlPricePriceEveryWeek.group2.oneDelivery = _delivery_price_week_13;
          var _delivery_price_week_14 = price * 1;
          app.xlPriceEveryTwoWeek.group2.oneDelivery = _delivery_price_week_14;
          var _delivery_price_week_15 = price_new * 1;
          app.xlPriceEveryThreeWeek.group2.oneDelivery = _delivery_price_week_15;
          var _delivery_price_week_16 = price_new * 1;
          app.xlPriceEveryFourWeek.group2.oneDelivery = _delivery_price_week_16;

          var _threeDelivery_price_week_13 = price * 3;
          app.xlPricePriceEveryWeek.group2.threeDelivery = _threeDelivery_price_week_13;
          var _threeDelivery_price_week_14 = price * 3;
          app.xlPriceEveryTwoWeek.group2.threeDelivery = _threeDelivery_price_week_14;
          var _threeDelivery_price_week_15 = price_new * 3;
          app.xlPriceEveryThreeWeek.group2.threeDelivery = _threeDelivery_price_week_15;
          var _threeDelivery_price_week_16 = price_new * 3;
          app.xlPriceEveryFourWeek.group2.threeDelivery = _threeDelivery_price_week_16;

          var _sixDelivery_price_week_13 = price * 6;
          app.xlPricePriceEveryWeek.group2.sixDelivery = _sixDelivery_price_week_13;
          var _sixDelivery_price_week_14 = price * 6;
          app.xlPriceEveryTwoWeek.group2.sixDelivery = _sixDelivery_price_week_14;
          var _sixDelivery_price_week_15 = price_new * 6;
          app.xlPriceEveryThreeWeek.group2.sixDelivery = _sixDelivery_price_week_15;
          var _sixDelivery_price_week_16 = price_new * 6;
          app.xlPriceEveryFourWeek.group2.sixDelivery = _sixDelivery_price_week_16;
        } else if (app.pickYourPrepaid.selectedStage == 'group-3') {
          var price = 0;
          var price_new = 0;
          if (app.pickYourPrepaid.grass.grassType == 'eastern Local' || app.pickYourPrepaid.grass.grassType == 'Local' || app.pickYourPrepaid.grass.grassType == 'Local Grass') {
            price = 3400;
            price_new = 3800;
          } else if (app.pickYourPrepaid.grass.grassType == 'Hydroponic') {
            price = 5000;
            price_new = 5800;
          }
          var _delivery_price_week_17 = price;
          app.xlPricePriceEveryWeek.group3.oneDelivery = _delivery_price_week_17;
          var _delivery_price_week_18 = price * 1;
          app.xlPriceEveryTwoWeek.group3.oneDelivery = _delivery_price_week_18;
          var _delivery_price_week_19 = price_new * 1;
          app.xlPriceEveryThreeWeek.group3.oneDelivery = _delivery_price_week_19;
          var _delivery_price_week_20 = price_new * 1;
          app.xlPriceEveryFourWeek.group3.oneDelivery = _delivery_price_week_20;

          var _threeDelivery_price_week_17 = price * 3;
          app.xlPricePriceEveryWeek.group3.threeDelivery = _threeDelivery_price_week_17;
          var _threeDelivery_price_week_18 = price * 3;
          app.xlPriceEveryTwoWeek.group3.threeDelivery = _threeDelivery_price_week_18;
          var _threeDelivery_price_week_19 = price_new * 3;
          app.xlPriceEveryThreeWeek.group3.threeDelivery = _threeDelivery_price_week_19;
          var _threeDelivery_price_week_20 = price_new * 3;
          app.xlPriceEveryFourWeek.group3.threeDelivery = _threeDelivery_price_week_20;

          var _sixDelivery_price_week_17 = price * 6;
          app.xlPricePriceEveryWeek.group3.sixDelivery = _sixDelivery_price_week_17;
          var _sixDelivery_price_week_18 = price * 6;
          app.xlPriceEveryTwoWeek.group3.sixDelivery = _sixDelivery_price_week_18;
          var _sixDelivery_price_week_19 = price_new * 6;
          app.xlPriceEveryThreeWeek.group3.sixDelivery = _sixDelivery_price_week_19;
          var _sixDelivery_price_week_20 = price_new * 6;
          app.xlPriceEveryFourWeek.group3.sixDelivery = _sixDelivery_price_week_20;
        }
      }
    },
    _weekSelection: function _weekSelection(event, variant_name) {
      app.pickYourPrepaid.selectedWeek = variant_name;
      $(event.currentTarget).parents('[data-prepaid-weeks]').addClass('d-none');
      app.pickYourPrepaid.frequency.selectedFrequency = variant_name;
      app._prepaidVariantSelection();
    },
    _prepaidVariantSelection: function _prepaidVariantSelection() {
      var week = app.pickYourPrepaid.selectedWeek;
      var month = app.pickYourPrepaid.selectedMonth;
      var variant_group = week + ' / ' + month;
      app.pickYourPrepaid.frequency.selectedFrequency = week;
      app.pickYourPrepaid.variantsGroup.forEach(function (item) {
        if (item.title == variant_group) {
          var variantID = item.id;
          var image = app._getSizedImageUrl(item.featured_image, '150x');
          var variantTitle = item.title;
          var productName = app.pickYourPrepaid.selectedProduct;
          app._pickYourPrepaidFrequently(event, productName, variantTitle, month, image, variantID);
        }
      });
    },
    _pickYourGrass: function _pickYourGrass(event, grass, image) {
      $('[data-frequently]').removeClass('d-none');
      $('[data-grass]').addClass('d-none');
      $('[data-frequently] [data-type-grasses] [data-grass-line]').each(function () {
        //const grassType = $(this).attr('[data-title]').toLowerCase();
        var grassType = $(this).attr('data-title').toLowerCase();
        //const Type = $(this).attr('data-title').toLowerCase();
        if (grassType.indexOf(grass) === -1) {
          $(this).addClass('d-none').removeClass('d-flex');
          $(this).remove();
        }
      });
      $('select.select_freq').val('Every 2 Weeks (Most Popular)').change();
      // eslint-disable-next-line max-statements-per-line
      if (grass != 'original') {
        app.pickYourPlan.grass.grassType = grass + " Local";
      } else {
        app.pickYourPlan.grass.grassType = 'Hydroponic';
      }
      app.pickYourPlan.grass.grassImage = image;
    },
    _pickYourPrepaidGrass: function _pickYourPrepaidGrass(event, grass, image) {
      $('[data-frequently]').removeClass('d-none');
      $('[data-grass]').addClass('d-none');
      $('[data-frequently] [data-type-grasses] [data-grass-line]').each(function () {
        var grassType = $(this).find('[data-title]').text().toLowerCase();
        if (grassType.indexOf(grass) === -1) {
          $(this).addClass('d-none').removeClass('d-flex');
        }
      });
      // eslint-disable-next-line max-statements-per-line
      if (grass != 'original') {
        app.pickYourPrepaid.grass.grassType = grass + " Local";
      } else {
        app.pickYourPrepaid.grass.grassType = 'Hydroponic';
      }
      app.pickYourPrepaid.grass.grassImage = image;
    },
    _selectFrequency: function _selectFrequency(event, tray_type) {
      document.querySelector('[data-changed-week]').classList.remove('d-none');
      // let selectElement = document.getElementById('fake_shipping_interval_frequency_');
      // let selectedOption = selectElement.options[selectElement.selectedIndex];
      // let frequencyQuantity = selectedOption.getAttribute('frequencyquantity');
      // localStorage.setItem('frequencyQuantity', frequencyQuantity);
      // console.log(frequencyQuantity);
      console.log(localStorage.getItem('itemCount'), 'hahahahahahah');
      if (localStorage.getItem('itemCount') === '4') {
        document.querySelector('[data-tray-group-1]').classList.remove('d-none');
      }
      // const frequency = document.querySelector('#selected_frequency').getAttribute('frequencyText');
      var inputString = document.querySelector('#selected_frequency').getAttribute('frequencyText');
      var a = inputString.split(' ').reverse();
      var b = a.splice(0, a.length - 1).pop();
      console.log(b);
      if (b === '1') {
        document.querySelector('.frequencyCount').classList.add('singleText');
      } else {
        document.querySelector('.frequencyCount').classList.remove('singleText');
      }
      document.querySelector('.frequencyCount').innerText = b === '1' ? 'Every' : b;
      document.querySelector('.frequencyWeekText').innerText = b === '1' ? 'week' : 'weeks';
      document.querySelector('[data-changed-week]').querySelector('.frequencyTextFunnel').innerText = document.querySelector('#selected_frequency').getAttribute('frequencyText');
      var global = $('[data-type-grasses] select.select_freq').find(':selected');
      var freq = global.attr('variant-title');
      var img = global.attr('variant-img');
      var v_id = global.attr('variant-id');
      app._pickYourPlanFrequently(event, '', freq, app._getSizedImageUrl(img, '150x'), v_id, tray_type);
    },
    _pickYourPlanFrequently: function _pickYourPlanFrequently(event, match, frequency, image, id, tray_type) {

      if (tray_type == '') {
        $("[data-tray-" + app.pickYourPlan.selectedStage + "], [data-details-product]").removeClass('d-none');
        $("[data-match-" + app.pickYourPlan.selectedStage + "], [data-frequently]").addClass('d-none');
      }

      var designSlider1 = document.querySelector('[data-image-design-slider]');
      var designSlider2 = document.querySelector('[data-image-design-slider-2]');

      if (designSlider1 != null) {
        var flkty4 = new Flickity('[data-image-design-slider]', _defineProperty({
          adaptiveHeight: false,
          draggable: true,
          contain: true,
          cellAlign: 'left',
          wrapAround: true,
          accessibility: true,
          dragThreshold: 20,
          lazyLoad: false,
          pageDots: false,
          prevNextButtons: true
        }, "contain", true));
      }

      if (designSlider2 != null) {
        var flkty5 = new Flickity('[data-image-design-slider-2]', _defineProperty({
          adaptiveHeight: false,
          draggable: true,
          contain: true,
          cellAlign: 'left',
          wrapAround: true,
          accessibility: true,
          dragThreshold: 20,
          lazyLoad: false,
          pageDots: false,
          prevNextButtons: true
        }, "contain", true));
      }

      var faq = 'Every week';
      app.pickYourPlan.shipping_interval_frequency = '1';
      if (frequency.indexOf('2') > -1) {
        faq = 'Every 2 weeks';
        app.pickYourPlan.shipping_interval_frequency = '2';
      } else if (frequency.indexOf('3') > -1) {
        faq = 'Every 3 weeks';
        app.pickYourPlan.shipping_interval_frequency = '3';
      } else if (frequency.indexOf('4') > -1) {
        faq = 'Every 4 weeks';
        app.pickYourPlan.shipping_interval_frequency = '4';
      }
      app.pickYourPlan.frequency.selectedFrequency = faq;
      app.pickYourPlan.frequency.frequencyImage = image;
      app.pickYourPlan.frequency.frequencyId = id;

      setTimeout(function () {
        if (tray_type != '') {
          $("[data-details-product] [data-tray-" + app.pickYourPlan.selectedStage + "]");
          var var_id = $("[data-details-product] [data-tray-" + app.pickYourPlan.selectedStage + "] [disp_tray]").val();
          app._addToCart(var_id, event, '', 'yes', 'Disposable DoggieLawn');
          $('[data-changed-week]').addClass('d-none');
        } else {
          $('[data-changed-week]').removeClass('d-none');
        }
      }, 100);
    },
    _pickYourPrepaidFrequently: function _pickYourPrepaidFrequently(event, match, frequency, charge_frequency, image, id) {
      $("[data-tray-" + app.pickYourPrepaid.selectedStage + "], [data-details-product]").removeClass('d-none');
      $("[data-match-" + app.pickYourPrepaid.selectedStage + "], [data-frequently]").addClass('d-none');
      var faq = '';
      // app.pickYourPrepaid.shipping_interval_frequency = '1';
      if (frequency.indexOf('Every Week') > -1) {
        faq = 'Every 1 week';
        app.pickYourPrepaid.shipping_interval_frequency = '1';
      } else if (frequency.indexOf('2 Weeks') > -1) {
        faq = 'Every 2 weeks';
        app.pickYourPrepaid.shipping_interval_frequency = '2';
      } else if (frequency.indexOf('3 Weeks') > -1) {
        faq = 'Every 3 weeks';
        app.pickYourPrepaid.shipping_interval_frequency = '3';
      } else if (frequency.indexOf('4 Weeks') > -1) {
        faq = 'Every 4 weeks';
        app.pickYourPrepaid.shipping_interval_frequency = '4';
      }
      if (faq.indexOf('1') > -1 && charge_frequency.indexOf('1') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '1';
      } else if (faq.indexOf('1') > -1 && charge_frequency.indexOf('3') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '3';
      } else if (faq.indexOf('1') > -1 && charge_frequency.indexOf('6') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '6';
      } else if (faq.indexOf('2') > -1 && charge_frequency.indexOf('1') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '2';
      } else if (faq.indexOf('2') > -1 && charge_frequency.indexOf('3') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '6';
      } else if (faq.indexOf('2') > -1 && charge_frequency.indexOf('6') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '12';
      } else if (faq.indexOf('3') > -1 && charge_frequency.indexOf('1') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '3';
      } else if (faq.indexOf('3') > -1 && charge_frequency.indexOf('3') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '9';
      } else if (faq.indexOf('3') > -1 && charge_frequency.indexOf('6') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '18';
      } else if (faq.indexOf('4') > -1 && charge_frequency.indexOf('1') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '4';
      } else if (faq.indexOf('4') > -1 && charge_frequency.indexOf('3') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '12';
      } else if (faq.indexOf('4') > -1 && charge_frequency.indexOf('6') > -1) {
        app.pickYourPrepaid.charge_interval_frequency = '24';
      }
      // let month = '1 Delivery';
      // app.pickYourPrepaid.charge_interval_frequency = '4';
      // if (charge_frequency.indexOf('3') > -1) {
      //   month = '3 Delivery';
      //   app.pickYourPrepaid.charge_interval_frequency = '12';
      // } else if (charge_frequency.indexOf('6') > -1) {
      //   month = '6 Delivery';
      //   app.pickYourPrepaid.charge_interval_frequency = '24';
      // } 
      app.pickYourPrepaid.frequency.selectedFrequency = faq;
      app.pickYourPrepaid.frequency.frequencyImage = image;
      app.pickYourPrepaid.frequency.frequencyId = id;
      app.pickYourPrepaid.month.selectedMonth = charge_frequency;
      var flkty4 = new Flickity('[data-image-design-slider]', _defineProperty({
        adaptiveHeight: false,
        draggable: true,
        contain: true,
        cellAlign: 'left',
        wrapAround: true,
        accessibility: true,
        dragThreshold: 20,
        lazyLoad: false,
        pageDots: false,
        prevNextButtons: true
      }, "contain", true));
      var flkty5 = new Flickity('[data-image-design-slider-2]', _defineProperty({
        adaptiveHeight: false,
        draggable: true,
        contain: true,
        cellAlign: 'left',
        wrapAround: true,
        accessibility: true,
        dragThreshold: 20,
        lazyLoad: false,
        pageDots: false,
        prevNextButtons: true
      }, "contain", true));
    },
    _backFrequency: function _backFrequency(event) {
      document.querySelector('[data-changed-week]').classList.add('d-none');
      $("[data-tray-" + app.pickYourPlan.selectedStage + "], [data-details-product]").addClass('d-none');
      $("[data-match-" + app.pickYourPlan.selectedStage + "], [data-frequently]").removeClass('d-none');
      app.pickYourPlan.frequency.selectedFrequency = '';
      app.pickYourPlan.frequency.frequencyImage = '';
      app.pickYourPlan.frequency.frequencyId = '';
    },
    _backPrepaidFrequency: function _backPrepaidFrequency(event) {

      $("[data-tray-" + app.pickYourPrepaid.selectedStage + "], [data-details-product]").addClass('d-none');
      $("[data-match-" + app.pickYourPrepaid.selectedStage + "], [data-frequently]").removeClass('d-none');
      $('[data-prepaid-weeks]').removeClass('d-none');
      $('[data-prepaid-months]').addClass('d-none');
      $('.data-prepaid-weeks').removeClass('d-none');
      $('.data-prepaid-months').addClass('d-none');
      app.pickYourPrepaid.frequency.selectedFrequency = '';
      app.pickYourPrepaid.frequency.frequencyImage = '';
      app.pickYourPrepaid.frequency.frequencyId = '';
      if (app.pickYourPrepaid.selectedStage == 'group-3') {
        if (app.pickYourPrepaid.grass.grassType === 'eastern Local' || app.pickYourPrepaid.grass.grassType === 'Local' || app.pickYourPrepaid.grass.grassType === 'Local Grass') {
          $('[data-eastern-weeks]').removeClass('d-none');
        } else {
          $('[data-group3-hydroponic-weeks]').removeClass('d-none');
        }
      } else if (app.pickYourPrepaid.selectedStage == 'group-2') {
        if (app.pickYourPrepaid.grass.grassType === 'central Local') {
          $('[data-central-weeks]').removeClass('d-none');
        } else {
          $('[data-group2-hydroponic-weeks]').removeClass('d-none');
        }
      }
    },
    _backPrepaidMonths: function _backPrepaidMonths() {
      $("[data-tray-" + app.pickYourPrepaid.selectedStage + "], [data-details-product]").addClass('d-none');
      $("[data-match-" + app.pickYourPrepaid.selectedStage + "], [data-frequently]").removeClass('d-none');
      $('[data-prepaid-months]').removeClass('d-none');
      $('.data-prepaid-months').removeClass('d-none');
      $('[data-prepaid-weeks]').addClass('d-none');
      $('.data-prepaid-weeks').addClass('d-none');
      $('[data-central-weeks]').addClass('d-none');
      $('[data-eastern-weeks]').addClass('d-none');
      $('[data-changed-week]').addClass('d-none');
      if (app.pickYourPrepaid.selectedStage == 'group-3') {
        if (app.pickYourPrepaid.grass.grassType === 'eastern Local' || app.pickYourPrepaid.grass.grassType === 'Local' || app.pickYourPrepaid.grass.grassType === 'Local Grass') {
          $('[data-eastern-weeks]').addClass('d-none');
        } else {
          $('[data-group3-hydroponic-weeks]').addClass('d-none');
        }
      } else if (app.pickYourPrepaid.selectedStage == 'group-2') {
        if (app.pickYourPrepaid.grass.grassType === 'central Local') {
          $('[data-central-weeks]').addClass('d-none');
        } else {
          $('[data-group2-hydroponic-weeks]').addClass('d-none');
        }
      }
      app.pickYourPrepaid.month.selectedMonth = '';
    },
    _toggleMedia: function _toggleMedia(event, media) {
      if (media == 'videos') {
        if ($(event.currentTarget).text().trim() === 'View More Videos/Podcasts') {
          $(event.currentTarget).text('Hide Videos/Podcasts');
        } else {
          $(event.currentTarget).text('View More Videos/Podcasts');
        }
        $('[data-hidden-videos]').toggleClass('d-none');
      } else if (media == 'images') {
        if ($(event.currentTarget).text().trim() === 'View More Images') {
          $(event.currentTarget).text('Hide Images');
        } else {
          $(event.currentTarget).text('View More Images');
        }
        $('[data-hidden-images]').toggleClass('d-none');
      }
    },
    _gorgias: function _gorgias() {
      var IframeInterval = setInterval(function () {
        if (document.querySelectorAll('#gorgias-chat-container iframe').length > 0) {
          GorgiasChat.open();
          clearInterval(IframeInterval);
          setTimeout(function () {
            $('.chat--widget .loader').hide();
            var header_height = $('header[data-site-header]').height() + $(".chat_title").height() + 140;
            var header_height = 'top: ' + header_height + 'px !important';
            document.querySelector('#gorgias-chat-container iframe#chat-window').style.cssText = header_height;
          }, 500);
        }
      }, 100);
    },
    _scrolltosection: function _scrolltosection(section, event) {
      $('html, body').animate({
        scrollTop: $(section).offset().top - 100
      }, 'false');
      if (event.keyCode != undefined) {
        $(section).find('h2').trigger('focus');
      }
    },
    _get_tray_swatch: function _get_tray_swatch(event) {
      var selected_variant = $(event.currentTarget).parents('[trays]').find('option[data_name="' + $(event.currentTarget).val() + '"]');
      var selected_id = selected_variant.attr('value');
      var selected_img = selected_variant.attr('data-image');
      $('.selected_tray').text($(event.currentTarget).val());
      $(event.currentTarget).parents('[trays]').find('[silicone_tray_img]').attr('src', selected_img);
      $(event.currentTarget).parents('[trays]').find('[silicon_tray_btn]').attr('data-var_id', selected_id);
    },
    _trayAdd: function _trayAdd(event) {
      var var_id = $(event.currentTarget).attr('data-var_id');
      app._addToCart(var_id, event, '', 'yes');
    },
    _select_tray: function _select_tray(event) {
      var tray = $('.tray_selection').val();
      if (tray == 'plastic_tray') {
        app._selectFrequency(event, '');
      } else {
        app._selectFrequency(event, "disposable");
      }
    }
  }
};

export default customMethods;